import React from 'react';
import {injectIntl} from "react-intl";
import {messages} from "../common/Translations";
import {Field, reduxForm} from 'redux-form';
import SubmitButton from "../common/SubmitButton";
import SelectInterests from "./SelectInterests";
import InterestField from "./InterestField";
import ReactSelectFormatter from "../../services/ReactSelectFormatter";

class InterestsForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {handleSubmit, portalsCategories} = this.props;
        let portals = Object.keys(portalsCategories);
        return (
            <form onSubmit={handleSubmit}>

                <div className="row">
                    <div className="col-12">
                        {
                            portals.map(portal => {
                                return <InterestField
                                    label={portal}
                                    options={ReactSelectFormatter.format(portalsCategories[portal])}
                                    placeholder={portal}
                                    name={portal}
                                    key={portal}
                                />
                            })

                        }
                    </div>
                </div>
                <hr/>
                <div className="row">
                    <div className="col-10 offset-2" style={{zIndex: 0}}>
                        <SubmitButton isUpdate={true}/>
                    </div>
                </div>
            </form>
        );
    }
}

InterestsForm = reduxForm({
    form: 'interests'
})(InterestsForm);

export default injectIntl(InterestsForm);


// WEBPACK FOOTER //
// ./web/src/components/interests/InterestsForm.jsx